import { render } from "./ModalPromoCodeMOO.vue?vue&type=template&id=543e001e&scoped=true"
import script from "./ModalPromoCodeMOO.vue?vue&type=script&lang=js"
export * from "./ModalPromoCodeMOO.vue?vue&type=script&lang=js"

import "./ModalPromoCodeMOO.vue?vue&type=style&index=0&id=543e001e&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543e001e"]])

export default __exports__